import React, { useEffect } from 'react';

import { AppRoutes } from '@/router/AppRoutes';
import { useUserStore } from '@/store/userStore';
import { getValidAuthToken, decodeToken } from '@/utils/auth';

const App: React.FC = () => {
  const setUser = useUserStore((state) => state.setUser);

  useEffect(() => {
    // Get valid (non-expired) token - automatically clears if expired
    const token = getValidAuthToken();

    if (token) {
      const decoded = decodeToken(token);

      if (decoded) {
        setUser({
          email: decoded.email ?? '',
          name: decoded.name ?? '',
          tenantId: decoded.tenantId ?? 0,
          isMaster: decoded.isMaster ?? false,
        });
      }
    }
  }, [setUser]);

  return <AppRoutes />;
};

export default App;
